import { enforceMinimumPrecision, formatDecimalPlaces } from '@sequencehq/utils'

/**
 * Net total for a credit note line item: rate × quantity. The price column is
 * derived from this (never edited directly), so it always matches what we send
 * to the API (which recomputes net from rate × quantity server-side). Rounded
 * to 2 decimal places to avoid floating-point artifacts (e.g. 9.99 × 3), and
 * padded to 2 decimal places so amounts display as money (5 → 5.00).
 */
export const lineItemNet = (rate: string, quantity: string): string => {
  const total = Number(rate) * Number(quantity)
  return enforceMinimumPrecision(2)(
    Number.isFinite(total) ? formatDecimalPlaces(total, 2) : '0'
  )
}
